import axiosClient, { axiosClientAdmin } from "@/lib/auth";
import {
  Comparator,
  GetGetMonitoringEventsMonitoringData,
  GetGetMonitoringEventsMonitoringResponse,
  GetGetMonitoringEventsMonitoringResponses,
} from "../types.gen";
import { UseQueryOptions } from "@tanstack/react-query";
import { SearchInput, SearchInputBase } from "../util/types";

export type SearchEventsInput = SearchInputBase & {
  companyId: string
  projectId: string
  videoProcessorId?: string,
  limit?: number
}

export const searchEvents = async (input: SearchEventsInput) => {
  const { companyId, projectId, videoProcessorId, ...rest } = input
  const pathTpl =
    "/Monitoring/event/search"
  const path = pathTpl

  const search = new SearchInput({
    pageSize: input.limit ?? undefined,
    ...rest,
  })
  if (videoProcessorId) {
    search.filterFilters.push({
      field: 'videoProcessorId',
      action: Comparator.Eq,
      value: videoProcessorId,
    })
  }

  if (projectId) {
    search.filterFilters.push({
      field: 'projectId',
      action: Comparator.Eq,
      value: projectId,
    })
  }

  if (companyId) {
    search.filterFilters.push({
      field: 'companyId',
      action: Comparator.Eq,
      value: companyId,
    })
  }

  const { data } = await axiosClientAdmin.get<GetGetMonitoringEventsMonitoringResponse>(path, {
    params: search.toParams()
  })

  return data
}

export const SearchEventsQuery = (input: SearchEventsInput) => {
  return {
    queryKey: ["events", input],
    queryFn: () => searchEvents(input),
  } satisfies UseQueryOptions
}

export const fetchEventImageUrl = async (eventValueId: string) => {
  const { data } = await axiosClientAdmin.get<{ url: string }>(`/Monitoring/event/value/${eventValueId}/url`)
  return data
}

export const FetchEventImageUrlQuery = (eventValueId: string) => {
  return {
    queryKey: ["eventImageUrl", eventValueId],
    queryFn: () => fetchEventImageUrl(eventValueId),
  } satisfies UseQueryOptions
}